export const IndustryModeEnum = {
    Dentistry: 'Dentistry',
    Pharmaceutical: 'Pharmaceutical',
    Labour: 'Trades'
  };

export const DefaultIndustryModeEnum = {
  Dentistry : "Dentistry",
  Pharmaceutical : "Pharmaceutical",
  Labour : "Trades",
  Custom : "Custom"
}
  export const paymentTypeEnum = {
    creditCard:'credit_card',
    pad:'pad',
    invoice:'invoice',
    rbPayroll:'rb_payroll'
  }
  export const formatPaymentType = (paymentType:any) =>{
    switch (paymentType) {
      case paymentTypeEnum.creditCard:
        return 'Credit Card';
      case paymentTypeEnum.pad:
        return 'Pre-Authorized Debit (PAD)';
      case paymentTypeEnum.invoice:
        return 'Traditional Invoice';
      case paymentTypeEnum.rbPayroll:
        return 'RB Pay';
      default:
        return 'Something is wrong';
    }
  }

export const getIndustryMode = () => IndustryModeEnum.Pharmaceutical;